{
  "type": {
    "harvesting": "Hogst",
    "silviculture": "Skogkultur",
    "both": "Hogst & skogkultur",
    "noResources": "Mangler ressurs"
  }
}
